import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { defineMessages } from 'react-intl-next';
export var EditDateMessages = /*#__PURE__*/function (EditDateMessages) {
  EditDateMessages["DatePlaceholder"] = "DatePlaceholder";
  return EditDateMessages;
}({});
export var IntlEditDateMessages = defineMessages(_defineProperty({}, EditDateMessages.DatePlaceholder, {
  id: 'form-system.DateQuestion.DatePlaceholder',
  defaultMessage: 'e.g. {date}'
}));